<template>
  <div>
    <header>
      <h1>选择距离更近的访问站点</h1>
      <h2>系统仅提供延迟参考，不会自动跳转。请确认后手动选择站点。</h2>
      <p class="site-notice">登录状态、积分余额和最多 5 台虚拟机的资源配额在所有站点通用。</p>
    </header>
    <main>
      <div id="results">
        <button v-for="(server, index) in servers" :key="index" :disabled="!server.active" :style="{
          backgroundColor:
            server.delay !== null
              ? server.isBest
                ? '#28a745'
                : '#007bff'
              : '#ccc',
        }" @click="navigateTo(server.url)">
          {{ server.name }} ({{
            server.delay !== null ? server.delay + "ms" : "无响应"
          }})
        </button>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      servers: [
        {
          name: "中国",
          url: "https://azlinux.com",
          status: "on",
          delay: null,
          active: false,
          isBest: false,
        },
        {
          name: "香港",
          url: "https://hk.azlinux.com",
          status: "on",
          delay: null,
          active: false,
          isBest: false,
        },
      ],
    };
  },
  mounted() {
    this.testDelays();
  },
  methods: {
    async testDelays() {
      this.servers.forEach((server) => {
        server.active = true;
      });

      const results = await Promise.all(
        this.servers.map((server) =>
          server.status === "on"
            ? this.pingServer(server)
            : Promise.resolve(server)
        )
      );

      results.sort((a, b) => (a.delay || Infinity) - (b.delay || Infinity));
      this.updateResults(results);
    },
    pingServer(server) {
      return new Promise((resolve) => {
        const start = performance.now();
        const controller = new AbortController();
        const timeout = setTimeout(() => {
          controller.abort();
          resolve({ ...server, delay: null });
        }, 5000);

        // The response body is intentionally not read. no-cors allows a
        // browser on either site to measure the other site's network delay.
        fetch(`${server.url}/favicon.ico?site_probe=${Date.now()}`, {
          cache: "no-store",
          mode: "no-cors",
          signal: controller.signal,
        })
          .then(() => {
            const delay = Math.max(1, Math.round(performance.now() - start));
            clearTimeout(timeout);
            resolve({ ...server, delay });
          })
          .catch(() => {
            clearTimeout(timeout);
            resolve({ ...server, delay: null });
          });
      });
    },
    updateResults(results) {
      this.servers = results.map((result, index) => {
        const isBest = index === 0 && result.delay !== null;
        return { ...result, active: result.status === "on", isBest };
      });
    },
    navigateTo(url) {
      window.location.href = url;
    },
  },
};
</script>


<style scoped>
body {
  font-family: "PingFang SC", "Microsoft YaHei", "Noto Sans CJK SC",
    "Source Han Sans SC", Arial, sans-serif;
  background-color: #f4f4f4;
  margin: 0;
  padding: 40px;
  text-align: center;
}

header {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

h1 {
  font-size: 1.4em;
  margin: 10px 0;
  color: #333;
}

h2 {
  font-size: 1.1em;
  margin: 10px 0;
  color: #444;
}

.site-notice {
  margin: 16px auto 0;
  color: #5f6b7a;
  font-size: 0.95rem;
}

#results {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 20px;
}

button {
  padding: 15px 30px;
  font-size: 1.1em;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  width: 340px;
  text-align: center;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
